import MDinput from '@/components/MDinput';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import Select from '@/components/DSE/Select';
import InputNumber from '@/components/DSE/InputNumber';

export function getFormDefinition(vue) {
  return {
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    parcelTypeOption: {
      type: Select,
      props: {
        caption: 'parcelType.parcelTypeOption',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('parcelType')
      },
      rules: [{ validator: validatorRequireNumber }]
    },
    maximumQuantity: {
      type: InputNumber,
      defaultValue: null,
      props: {
        caption: 'parcelType.maximumQuantity',
        step: 1
      }
    },
    maximumWeightInKg: {
      type: InputNumber,
      defaultValue: null,
      props: {
        caption: 'parcelType.maximumWeightInKg',
        precision: 3,
        step: 1
      }
    },
    maximumLengthInM: {
      type: InputNumber,
      defaultValue: null,
      props: {
        caption: 'parcelType.maximumLengthInM',
        precision: 3,
        step: 1
      }
    },
    alternativeParcelTypeID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'parcelType.alternativeParcelType',
        valueField: 'id',
        labelField: 'description',
        loading: vue.$store.getters['parcelType/isLoading']
      },
      dynamicProps: form => {
        return {
          options: vue.$store.getters['parcelType/loadedItems'].filter(i => i.id !== form.id)
        };
      }
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
